export const MenuList = [
  //Dashboard
  {
    title: "",
    classsChange: "menu-title",
    extraclass: "first",
  },
  //Dashboard
  // {
  //   title: "Dashboard",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="la la-home" />,
  //   content: [
  //     {
  //       title: "Dashboard",
  //       to: "dashboard",
  //     },
  //     // {
  //     //     title: 'Dashboard 2',
  //     //     to: 'index-2',
  //     // },
  //     // {
  //     //     title: 'Dashboard 3',
  //     //     to: 'index-3',
  //     // },
  //   ],
  // },

  //Management
  // {
  //   title: "Event Management",
  //   to: "event-management",
  //   iconStyle: <i className="la la-calendar" />,
  // },
  //companies
  // {
  //   title: "Companies",
  //   module: "companies",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="la la-user" />,
  //   content: [
  //     // {
  //     //   title: "Categories",
  //     //   to: "company-categories",
  //     // },
  //     {
  //       title: "Add Company",
  //       to: "add-company ",
  //     },
  //     {
  //       title: "All Companies",
  //       to: "companies",
  //     },

  //     // {
  //     //   title: "Company Profile",
  //     //   to: "company-profile",
  //     // },
  //   ],
  // },
  //projects
  // {
  //   title: "Projects",
  //   module: "projects",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="la la-user" />,
  //   content: [
  //     {
  //       title: "Add Project",
  //       to: "add-project ",
  //     },
  //     {
  //       title: "All Projects",
  //       to: "projects",
  //     },
  //     // {
  //     //   title: "Categories",
  //     //   to: "project-categories",
  //     // },

  //     // {
  //     //   title: "Company Profile",
  //     //   to: "company-profile",
  //     // },
  //   ],
  // },
  // {
  //   title: "Messages",
  //   hasMenu: true,
  //   iconStyle: (
  //     <i className="fa-solid fa-comment-dots" style={{ color: "#22C55E" }} />
  //   ),
  //   content: [{ title: "Messages", to: "chat", public: true }],
  // },
  //workforce
  {
    title: "Workforce",
    module: "workforce",
    classsChange: "mm-collapse",
    iconStyle: <i className="fa-solid fa-users" style={{ color: "#818CF8" }} />,
    content: [
      {
        title: "Add",
        to: "add-staff",
        pageKey: "workforce.allStaff",
      },
      {
        title: "All Staff",
        to: "all-staff",
        pageKey: "workforce.allStaff",
      },
      {
        title: "Reset Password",
        to: "staff/reset-password",
        roles: ["super-admin"],
      },
      // {
      //   title: "Movement Register",
      //   to: "movement-register",
      //   pageKey: "workforce.movementRegister",
      // },
      {
        title: "Staff Reporting",
        to: "staff-reporting",
        pageKey: "workforce.staffReporting",
      },
      {
        title: "PM Combined Report",
        to: "staff-reporting/pm-combined",
        roles: ["super-admin", "Project Manager"],
      },
      {
        title: "Team Real Estate",
        to: "real-estate-team",
        roles: ["super-admin"],
        reTeamHead: true, // also shown to anyone heading a Real Estate team
      },
      // {
      //   title: "Team Combined Report",
      //   to: "real-estate-team/club-report",
      //   roles: ["super-admin"],
      //   reTeamHead: true, // also shown to anyone heading a Real Estate team
      // },
      {
        title: "Team Netplus",
        to: "netplus-team",
        roles: ["super-admin", "Manager Netplus"],
      },
      // {
      //   title: "Netplus Reports",
      //   to: "netplus-team/reports",
      //   roles: ["super-admin", "Manager Netplus"],
      // },
      {
        title: "Customer Database",
        to: "staff-reporting/customers",
        pageKey: "workforce.staffReporting.customers",
      },
      {
        title: "CP / Customer Visitors",
        to: "staff-reporting/visitors",
        roles: ["super-admin", "Real Estate Sales", "Manager Real Estate"],
        reTeamHead: true, // also shown to anyone heading a Real Estate team
      },
      // {
      //   title: "Team Efforts Report",
      //   to: "staff-reporting/efforts",
      //   pageKey: "workforce.staffReporting.efforts",
      // },
      {
        title: "Performance Review",
        to: "performance-review",
        roles: ["super-admin"],
      },
      {
        title: "Salary Sheet",
        to: "salary-sheet",
        roles: ["super-admin"],
      },
      {
        title: "CP Database",
        to: "cp-database",
        pageKey: "workforce.cpDatabase",
      },
    ],
  },
  // ── Reports (isolated feature modules live under here) ──────────────────────
  // Visible to a single user only — `userIds` gates the whole group by user id
  // regardless of role or any staff `module` grant (see isVisible in SideBar.jsx).
  {
    title: "Reports",
    userIds: ["6aa647b116033bff40dc58f4"],
    classsChange: "mm-collapse",
    iconStyle: (
      <i
        className="fa-solid fa-file-invoice-dollar"
        style={{ color: "#0EA5E9" }}
      />
    ),
    content: [
      { title: "Daily Report Summary", to: "reports/daily-summary" },
      { title: "Netplus Banks", to: "bank-accounts" },
      { title: "My Tasks", to: "tasks" },
      { title: "Work List", to: "tasks/work-list" },
    ],
  },
  // ── Contract Workers (isolated feature module) ──────────────────────────────
  // Kept separate from the staff Workforce group above. `module` is a private
  // key that resolves to "none" for every non-super-admin, so the whole group
  // is super-admin-only without touching the staff permission matrix.
  {
    title: "Contract Workers",
    module: "contractWorkers",
    classsChange: "mm-collapse",
    iconStyle: (
      <i className="fa-solid fa-helmet-safety" style={{ color: "#F59E0B" }} />
    ),
    content: [
      { title: "Create Worker", to: "contract-workers/add" },
      { title: "Attendance", to: "contract-workers/attendance" },
      { title: "Daily Roster", to: "contract-workers/daily-roster" },
      { title: "Worker Roster", to: "contract-workers/roster" },
    ],
  },
  {
    title: "Attendance",
    hasMenu: true,
    iconStyle: (
      <i className="fa-solid fa-clipboard-user" style={{ color: "#38BDF8" }} />
    ),
    content: [
      {
        title: "Punch In / Out",
        to: "staff/attendance/punch",
        pageKey: "workforce.attendance.punch",
      },
      {
        title: "My Calendar",
        to: "staff/attendance/calendar",
        pageKey: "workforce.attendance.calendar",
      },
      {
        title: "Daily Roster",
        to: "staff/attendance/roster",
        pageKey: "workforce.attendance.roster",
      },
      {
        title: "Working Hours",
        to: "staff/attendance/working-hours",
        pageKey: "workforce.attendance.roster",
      },
      {
        title: "Workplace Config",
        to: "staff/attendance/workplace-settings",
        pageKey: "workforce.attendance.settings",
      },
    ],
  },
  {
    title: "Leave",
    hasMenu: true,
    iconStyle: (
      <i className="fa-solid fa-calendar-minus" style={{ color: "#FB923C" }} />
    ),
    content: [
      {
        title: "Apply Leave",
        to: "staff/leave/apply",
        pageKey: "workforce.leave.apply",
        hideForRoles: ["super-admin"],
      },
      {
        title: "My Leaves",
        titleByRole: { "super-admin": "Leave Applications" },
        to: "staff/leave/list",
        pageKey: "workforce.leave.list",
      },
    ],
  },
  {
    title: "Employee Advances",
    module: "advances",
    classsChange: "mm-collapse",
    iconStyle: (
      <i
        className="fa-solid fa-money-bill-transfer"
        style={{ color: "#34D399" }}
      />
    ),
    content: [
      {
        title: "Add Advance",
        to: "advances/add",
        pageKey: "workforce.advances",
      },
      {
        title: "All Advances",
        to: "advances",
        pageKey: "workforce.advances",
      },
    ],
  },
  {
    title: "Sales",
    module: "sales",
    to: "sales",
    iconStyle: (
      <i
        className="fa-solid fa-hand-holding-dollar"
        style={{ color: "#F59E0B" }}
      />
    ),
  },
  {
    title: "Hotel Feedback",
    module: "hotelFeedback",
    classsChange: "mm-collapse",
    iconStyle: <i className="fa-solid fa-star" style={{ color: "#F59E0B" }} />,
    content: [
      { title: "Feedback", to: "hotel-feedback" },
      { title: "Feedback List", to: "hotel-feedback/list" },
    ],
  },
  {
    title: "Kitty Report",
    module: "kittyReport",
    to: "kitty-report",
    iconStyle: (
      <i className="fa-solid fa-piggy-bank" style={{ color: "#EC4899" }} />
    ),
  },
  {
    title: "Netplus Hub",
    module: "netplusReceipts",
    classsChange: "mm-collapse",
    iconStyle: <i className="fa-solid fa-wifi" style={{ color: "#22D3EE" }} />,
    content: [
      // ── Receipts ──
      { title: "Add Receipt", to: "netplus/add" },
      { title: "All Receipts", to: "netplus" },
      { title: "Transfer History", to: "netplus/transfers" },
      // ── Customer Status Report ── (daily subscriber sheet, per partner)
      // Gated by its own module — only staff granted `netplusCustomerStatus`
      // in their profile see these screens, regardless of the Netplus Hub grant.
      {
        title: "Customer Status Report",
        hasMenu: true,
        module: "netplusCustomerStatus",
        content: [
          { title: "Dashboard", to: "netplus/customer-status" },
          { title: "Upload Sheet", to: "netplus/customer-status/upload" },
          { title: "Follow-ups", to: "netplus/customer-status/followups" },
          { title: "Team", to: "netplus/customer-status/team" },
          { title: "Customers", to: "netplus/customer-status/customers" },
          {
            title: "New Connections",
            to: "netplus/customer-status/new-connections",
          },

          { title: "Daily Report", to: "netplus/customer-status/daily-report" },
          { title: "Transitions", to: "netplus/customer-status/transitions" },
          {
            title: "Modem Recovery",
            to: "netplus/customer-status/modem-recovery",
          },
          {
            title: "Modem Hand Over",
            to: "netplus/customer-status/modem-handover",
          },
          { title: "Scan Modem", to: "netplus/scan-modem" },
          {
            title: "Field Sheet Reconciliation",
            to: "netplus/customer-status/reconciliation",
            roles: ["super-admin"],
          },

          { title: "Audit Log", to: "netplus/customer-status/audit" },
          { title: "Performance", to: "netplus/customer-status/performance" },
          {
            title: "Incentive Revenue",
            to: "netplus/customer-status/incentive",
            roles: ["super-admin"],
          },
          {
            title: "Employee Daily",
            to: "netplus/customer-status/employee-daily",
          },
          { title: "My Daily Report", to: "netplus/customer-status/my-daily" },
          { title: "Freelancer", to: "netplus/customer-status/freelancer" },
          // {
          //   title: "Performance Review",
          //   to: "performance-review",
          //   roles: ["super-admin"],
          // },
        ],
      },
      // ── Complaints ── (daily CSV/Excel upload, matched on Ticket No)
      {
        title: "Complaints",
        hasMenu: true,
        module: "netplusComplaints",
        content: [
          { title: "Upload", to: "netplus/complaints/upload" },
          { title: "List", to: "netplus/complaints/list" },
        ],
      },
      // ── Bank Reconciliation ── (bank statement vs our deposits, per period)
      { title: "Bank Reconciliation", to: "netplus/bank-recon" },
      // ── Modem ledgers ──
      // Per-employee running ledger: opening balance − recovered −
      // recharged/retained − in-hand − not-found + new cases = carry-forward.
      // Not project-scoped.
      // {
      //   title: "Modem Recovery",
      //   to: "modem-recovery",
      //   pageKey: "workforce.modemRecovery",
      // },
      // Named follow-up trail for the ledger's Untraceable tally — one case
      // per customer, dated remarks until it's closed.
      // {
      //   title: "Untraceable",
      //   to: "untraceable-cases",
      //   pageKey: "workforce.modemRecovery",
      // },
      // Per-project bucket ledger (Inactive / Suspended / Terminated).
      // Backend limits it to the Satti & Co project.
      // { title: "Modem Status", to: "netplus/modem-status" },
    ],
  },
  //Revenue
  {
    title: "Finance",
    module: "finance",
    classsChange: "mm-collapse",
    iconStyle: (
      <i className="fa-solid fa-sack-dollar" style={{ color: "#FBBF24" }} />
    ),
    content: [
      {
        title: "Expense Heads",
        to: "/payments/category-heads",
      },
      {
        title: "Pay",
        to: "/payments/add/expense",
      },
      {
        title: "Daybook",
        to: "/payments/payments",
      },
      {
        title: "Employee Daybook",
        to: "imprest/admin",
        roles: ["super-admin"],
      },
      {
        title: "Category Report",
        to: "/payments/finance/category-summary",
      },

      // {
      //   title: "Fees Receipt",
      //   to: "fees-receipt",
      // },
    ],
  },
  {
    title: "Imprest",
    classsChange: "mm-collapse",
    iconStyle: (
      <i className="fa-solid fa-wallet" style={{ color: "#A78BFA" }} />
    ),
    content: [
      { title: "My Imprest", to: "imprest", pageKey: "workforce.imprest" },
      { title: "Allot Imprest", to: "imprest/allot", roles: ["super-admin"] },
      { title: "All Employees", to: "imprest/admin", roles: ["super-admin"] },
      {
        title: "Expenses Report",
        to: "imprest/expenses-report",
        roles: ["super-admin"],
      },
    ],
  },

  // Finance
  {
    title: "Inventory",
    module: "inventory",
    classsChange: "mm-collapse",
    iconStyle: (
      <i className="fa-solid fa-truck-ramp-box" style={{ color: "#F472B6" }} />
    ),
    content: [
      {
        title: "Store",
        hasMenu: true,
        content: [
          {
            title: "Add SKU",
            to: "/inventory/sku",
          },
          {
            title: "Issue Stock",
            to: "/inventory/issue",
          },
          {
            title: "List",
            to: "/inventory/store",
          },
        ],
      },
      {
        title: "Edit Requests",
        to: "/inventory/edit-requests",
        roles: ["super-admin", "sub-admin"],
      },
    ],
  },
  // suppliers
  {
    title: "Suppliers",
    module: "suppliers",
    classsChange: "mm-collapse",
    iconStyle: (
      <i
        className="fa-solid fa-people-carry-box"
        style={{ color: "#4ADE80" }}
      />
    ),
    content: [
      {
        title: "Add +",
        to: "add-supplier",
      },
      // {
      //   title: "Supplier Payments",
      //   to: "supplier-payments",
      // },
    ],
  },
  // contractors
  {
    title: "Contractors",
    module: "contractors",
    classsChange: "mm-collapse",
    iconStyle: (
      <i className="fa-solid fa-helmet-safety" style={{ color: "#FB7185" }} />
    ),
    content: [
      {
        title: "Category",
        to: "contractor-categories",
      },
      {
        title: "Add +",
        to: "add-contractor",
      },
      // {
      //   title: "Contractor Payments",
      //   to: "contractor-payments",
      // },
    ],
  },
  {
    title: "Equipments",
    module: "equipments",
    classsChange: "mm-collapse",
    iconStyle: (
      <i className="fa-solid fa-tractor" style={{ color: "#FCD34D" }} />
    ),
    content: [
      {
        title: "Add Equipment",
        to: "progress/equipement/add",
      },
      {
        title: "Service Logs",
        to: "progress/equipement/detail",
      },
      {
        title: "Equipment List",
        to: "progress/equipement/list",
      },
      {
        title: "Relocate Equipment",
        to: "progress/equipement/relocate",
      },
    ],
  },
  {
    title: "Assets",
    module: "equipments",
    classsChange: "mm-collapse",
    iconStyle: (
      <i className="fa-solid fa-boxes-stacked" style={{ color: "#FCD34D" }} />
    ),
    content: [
      { title: "Add Asset", to: "assets/add" },
      { title: "Asset List", to: "assets/list" },
    ],
  },
  // Daily Progress Report
  // {
  //   title: "Daily Progress",
  //   module: "workProgress",
  //   classsChange: "mm-collapse",
  //   iconStyle: (
  //     <i className="fa-solid fa-clipboard-list" style={{ color: "#60A5FA" }} />
  //   ),
  //   content: [
  //     {
  //       title: "Add Morning Report",
  //       to: "progress/workprogress/add",
  //     },
  //     {
  //       title: "Add Daily Report",
  //       to: "progress/daily-material/add",
  //     },
  //     {
  //       title: "Morning Reports",
  //       to: "progress/workprogress/list",
  //     },
  //     {
  //       title: "Daily Progress Report",
  //       to: "progress/daily-material/list",
  //     },
  //   ],
  // },
  // Labour management
  // {
  //   title: "Labour Management",
  //   module: "labour",
  //   classsChange: "mm-collapse",
  //   iconStyle: (
  //     <i className="fa-solid fa-user-group" style={{ color: "#2DD4BF" }} />
  //   ),
  //   content: [
  //     {
  //       title: "Labour Type",
  //       to: "labour-type",
  //     },
  //     {
  //       title: "Labour Payments",
  //       to: "finance/labour-summary",
  //     },
  // {
  //   title: "Add Labour",
  //   to: "add-labour",
  // },
  // {
  //   title: "Edit Labour",
  //   to: "edit-labour",
  // },
  //   ],
  // },
  //customers
  // {
  //   title: "Customers",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="la la-users" />,
  //   content: [
  //     {
  //       title: "All Customers",
  //       to: "all-customers",
  //     },
  // {
  //   title: "Add Customers",
  //   to: "add-customer   ",
  // },
  //   {
  //     title: "Edit Customers",
  //     to: "edit-customers",
  //   },
  //   {
  //     title: "About Students",
  //     to: "about-student",
  //   },
  //   ],
  // },

  //Courses
  // {
  //   title: "Blogs",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="la la-graduation-cap" />,
  //   content: [
  //     {
  //       title: "All Blogs",
  //       to: "all-blogs",
  //     },
  //     {
  //       title: "Add Blog",
  //       to: "add-blog",
  //     },
  // {
  //   title: "Edit Blog",
  //   to: "all-blogs",
  // },
  // {
  //   title: "Blog Detail",
  //   to: "blog-detail",
  // },
  // {
  //   title: "Add Category",
  //   to: "blog-category",
  // },
  //   ],
  // },
  {
    title: "Vehicles/Machines",
    module: "vehicles",
    classsChange: "mm-collapse",
    iconStyle: <i className="fa-solid fa-truck" style={{ color: "#C084FC" }} />,
    content: [
      {
        title: "Add",
        to: "add-vehicle",
      },
      {
        title: "List",
        to: "vehicles",
      },
      {
        title: "Assign Vehicle",
        to: "/vehicle/assign",
      },
      {
        title: "Vehicle Expenses",
        to: "/payments/vehicle/expenses",
      },
      {
        title: "Vehicle Report",
        to: "/payments/finance/vehicle-summary",
      },

      // {
      //   title: "Fees Receipt",
      //   to: "fees-receipt",
      // },
    ],
  },

  // MD Schedule
  {
    title: "MD Schedule",
    module: "mdSchedule",
    classsChange: "mm-collapse",
    iconStyle: (
      <i className="fa-solid fa-calendar-check" style={{ color: "#F87171" }} />
    ),
    content: [
      {
        title: "Add",
        to: "md-schedule/create",
      },
      {
        title: "List",
        to: "md-schedule",
      },
    ],
  },

  //sessions
  // {
  //   title: "Sessions",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="la la-calendar" />,
  //   content: [
  //     {
  //       title: "All Sessions",
  //       to: "all-sessions",
  //     },
  //   ],
  // },

  //Library
  // {
  //   title: "Library",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="la la-book" />,
  //   content: [
  //     {
  //       title: "All Library",
  //       to: "all-library",
  //     },
  //     {
  //       title: "Add Library",
  //       to: "add-library",
  //     },
  //     {
  //       title: "Edit Library",
  //       to: "edit-library",
  //     },
  //   ],
  // },
  //Departments
  // {
  //   title: "Departments",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="la la-building" />,
  //   content: [
  //     {
  //       title: "All Departments",
  //       to: "all-departments",
  //     },
  //     {
  //       title: "Add Departments",
  //       to: "add-departments",
  //     },
  //     {
  //       title: "Edit Departments",
  //       to: "edit-departments",
  //     },
  //   ],
  // },

  //Holiday
  // {
  //   title: "Holiday",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="la la-gift" />,
  //   content: [
  //     {
  //       title: "All Holiday",
  //       to: "all-holiday",
  //     },
  //     {
  //       title: "Add Holiday",
  //       to: "add-holiday",
  //     },
  //     {
  //       title: "Edit Holiday",
  //       to: "edit-holiday",
  //     },
  //     {
  //       title: "Holiday Calendar",
  //       to: "holiday-calendar",
  //     },
  //   ],
  // },

  //Apps
  // {
  //   title: "Apps",
  //   classsChange: "menu-title",
  // },
  // {
  //   title: "Apps",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="la la-users" />,
  //   content: [
  //     {
  //       title: "Profile",
  //       to: "app-profile",
  //     },
  //     {
  //       title: "Edit Profile",
  //       to: "edit-profile",
  //     },
  //     {
  //       title: "Post Details",
  //       to: "post-details",
  //     },
  //     {
  //       title: "Email",
  //       hasMenu: true,
  //       content: [
  //         {
  //           title: "Compose",
  //           to: "email-compose",
  //         },
  //         {
  //           title: "Index",
  //           to: "email-inbox",
  //         },
  //         {
  //           title: "Read",
  //           to: "email-read",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Calendar",
  //       to: "app-calender",
  //     },
  //     {
  //       title: "Shop",
  //       //to: './',
  //       hasMenu: true,
  //       content: [
  //         {
  //           title: "Product Grid",
  //           to: "ecom-product-grid",
  //         },
  //         {
  //           title: "Product List",
  //           to: "ecom-product-list",
  //         },
  //         {
  //           title: "Product Details",
  //           to: "ecom-product-detail",
  //         },
  //         {
  //           title: "Order",
  //           to: "ecom-product-order",
  //         },
  //         {
  //           title: "Checkout",
  //           to: "ecom-checkout",
  //         },
  //         {
  //           title: "Invoice",
  //           to: "ecom-invoice",
  //         },
  //         {
  //           title: "Customers",
  //           to: "ecom-customers",
  //         },
  //       ],
  //     },
  //   ],
  // },

  //CMS
  // {
  //   title: "CMS",
  //   classsChange: "mm-collapse",
  //   // update:"New",
  //   iconStyle: <i className="flaticon-381-database-1" />,
  //   content: [
  //     {
  //       title: "Content",
  //       to: "/content",
  //     },
  //     {
  //       title: "Menu",
  //       to: "/menu",
  //     },
  //     {
  //       title: "Email Template",
  //       to: "/email-template",
  //     },
  //     {
  //       title: "Blog",
  //       to: "/blog",
  //     },
  //     {
  //       title: "Add Content",
  //       to: "/content-add",
  //     },
  //     {
  //       title: "Add Email",
  //       to: "/add-email",
  //     },
  //     {
  //       title: "Add Blog",
  //       to: "/add-blog",
  //     },
  //     {
  //       title: "Blog Category",
  //       to: "/blog-category",
  //     },
  //   ],
  // },
  //Charts
  // {
  //   title: "Charts",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="la la-signal" />,
  //   content: [
  //     {
  //       title: "RechartJs",
  //       to: "chart-rechart",
  //     },
  //     {
  //       title: "Chartjs",
  //       to: "chart-chartjs",
  //     },
  //     {
  //       title: "Sparkline",
  //       to: "chart-sparkline",
  //     },
  //     {
  //       title: "Apexchart",
  //       to: "chart-apexchart",
  //     },
  //   ],
  // },
  // {
  //   title: "Components",
  //   classsChange: "menu-title",
  // },

  //Boosttrap
  // {
  //   title: "Bootstrap",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="la la-globe"></i>,
  //   content: [
  //     {
  //       title: "Accordion",
  //       to: "ui-accordion",
  //     },
  //     {
  //       title: "Alert",
  //       to: "ui-alert",
  //     },
  //     {
  //       title: "Badge",
  //       to: "ui-badge",
  //     },
  //     {
  //       title: "Button",
  //       to: "ui-button",
  //     },
  //     {
  //       title: "Modal",
  //       to: "ui-modal",
  //     },
  //     {
  //       title: "Button Group",
  //       to: "ui-button-group",
  //     },
  //     {
  //       title: "List Group",
  //       to: "ui-list-group",
  //     },
  //     {
  //       title: "Cards",
  //       to: "ui-card",
  //     },
  //     {
  //       title: "Carousel",
  //       to: "ui-carousel",
  //     },
  //     {
  //       title: "Dropdown",
  //       to: "ui-dropdown",
  //     },
  //     {
  //       title: "Popover",
  //       to: "ui-popover",
  //     },
  //     {
  //       title: "Progressbar",
  //       to: "ui-progressbar",
  //     },
  //     {
  //       title: "Tab",
  //       to: "ui-tab",
  //     },
  //     {
  //       title: "Typography",
  //       to: "ui-typography",
  //     },
  //     {
  //       title: "Pagination",
  //       to: "ui-pagination",
  //     },
  //     {
  //       title: "Grid",
  //       to: "ui-grid",
  //     },
  //   ],
  // },
  //plugins
  // {
  //   title: "Plugins",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="la la-plus-square-o"></i>,
  //   content: [
  //     {
  //       title: "Select 2",
  //       to: "uc-select2",
  //     },

  //     {
  //       title: "Sweet Alert",
  //       to: "uc-sweetalert",
  //     },
  //     {
  //       title: "Toastr",
  //       to: "uc-toastr",
  //     },
  //     {
  //       title: "Light Gallery",
  //       to: "uc-lightgallery",
  //     },
  //   ],
  // },
  //Widget
  // {
  //   title: "Widget",
  //   iconStyle: <i className="la la-desktop" />,
  //   classsChange: "mm-collapse",
  //   content: [
  //     {
  //       title: "Widget Card",
  //       to: "widget-card",
  //     },
  //     {
  //       title: "Widget Chart",
  //       to: "widget-chart",
  //     },
  //     {
  //       title: "Widget List",
  //       to: "widget-list",
  //     },
  //   ],
  // },

  // {
  //   title: "Forms",
  //   classsChange: "menu-title",
  // },
  //Forms
  // {
  //   title: "Forms",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="la la-file-text" />,
  //   content: [
  //     {
  //       title: "Form Elements",
  //       to: "form-element",
  //     },
  //     {
  //       title: "Wizard",
  //       to: "form-wizard",
  //     },
  //     {
  //       title: "CkEditor",
  //       to: "form-ckeditor",
  //     },
  //     {
  //       title: "Pickers",
  //       to: "form-pickers",
  //     },
  //     {
  //       title: "Form Validate",
  //       to: "form-validation",
  //     },
  //   ],
  // },

  //Table
  // {
  //   title: "Table",
  //   classsChange: "menu-title",
  // },
  // {
  //   title: "Table",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="la la-table" />,
  //   content: [
  //     {
  //       title: "Table Filtering",
  //       to: "table-filtering",
  //     },
  //     {
  //       title: "Table Sorting",
  //       to: "table-sorting",
  //     },
  //     {
  //       title: "Bootstrap",
  //       to: "table-bootstrap-basic",
  //     },
  //   ],
  // },
  //Pages
  //Table
  // {
  //   title: "Extra",
  //   classsChange: "menu-title",
  // },
  // {
  //   title: "Pages",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="la la-th-list" />,
  //   content: [
  //     {
  //       title: "Error",
  //       hasMenu: true,
  //       content: [
  //         {
  //           title: "Error 400",
  //           to: "page-error-400",
  //         },
  //         {
  //           title: "Error 403",
  //           to: "page-error-403",
  //         },
  //         {
  //           title: "Error 404",
  //           to: "page-error-404",
  //         },
  //         {
  //           title: "Error 500",
  //           to: "page-error-500",
  //         },
  //         {
  //           title: "Error 503",
  //           to: "page-error-503",
  //         },
  //       ],
  //     },
  //     {
  //       title: "Lock Screen",
  //       to: "page-lock-screen",
  //     },
  //   ],
  // },
];
